import { createSelector } from "reselect";
import { Map } from "immutable";

export const shouldDisplay = ({ cards2: cards }) => {
  return cards.imageDisplay.get("display");
};

export const cardInfo = ({ cards2: cards }) => {
  const cardImages = cards.cardImages.get(cards.imageDisplay.get("cardId"));
  const cardFront = (cardImages && cardImages.get("front")) || null;
  const cardBack = (cardImages && cardImages.get("back")) || null;
  const cardError = (cardImages && cardImages.get("error")) || "";

  return { cardFront, cardBack, cardError };
};
